import { Environment } from '../environments/environment'
import { LocaleId } from '../models'

type Link = string
type LinkLocalized = Record<LocaleId, Link>

interface LinkConfig {
  accessibilityStatement: LinkLocalized
  rentYourOwnHolidayWeek: LinkLocalized
  store: LinkLocalized
  storeServices: Link
  termsOfBookings: LinkLocalized
  termsOfDigitalServices: Link
  termsOfOwnership: Link
  termsOfRental: Link
  webshop: Link
  webshopSignUpComplete: Link
  welcomePresentation: Link
}

/* Query param provided to help syncing sessions */
const LOMA_REFERENCE_QUERY = '?ref=loma'

export const LINK_CONFIG: LinkConfig = {
  accessibilityStatement: {
    [LocaleId.EnUS]: `${Environment.API.Webshop.url}${LOMA_REFERENCE_QUERY}/en/footermenu/our-web-service/accessibility-statement/`,
    [LocaleId.Fi]: `${Environment.API.Webshop.url}${LOMA_REFERENCE_QUERY}/fi/footermenu/verkkopalvelustamme/saavutettavuusseloste-omat-lomasivut/`,
  },
  rentYourOwnHolidayWeek: {
    [LocaleId.EnUS]: `${Environment.API.Webshop.url}${LOMA_REFERENCE_QUERY}/en/ownership/viikko-osake/renting-out/`,
    [LocaleId.Fi]: `${Environment.API.Webshop.url}${LOMA_REFERENCE_QUERY}/fi/omistaminen/viikko-osake/vuokravalitys#lomakkeet`,
  },
  store: {
    [LocaleId.EnUS]: `${Environment.API.Webshop.url}${LOMA_REFERENCE_QUERY}/en/store`,
    [LocaleId.Fi]: `${Environment.API.Webshop.url}${LOMA_REFERENCE_QUERY}/fi/store/?`,
  },
  storeServices: `${Environment.API.Webshop.url}${LOMA_REFERENCE_QUERY}/fi/store/lisapalvelut-uusi/lista`,
  termsOfBookings: {
    [LocaleId.EnUS]: `${Environment.API.Webshop.url}${LOMA_REFERENCE_QUERY}/en/booking-terms-and-conditions/terms-and-conditions/`,
    [LocaleId.Fi]: `${Environment.API.Webshop.url}${LOMA_REFERENCE_QUERY}/fi/varausehdot/yhdistetyt-ehdot/`,
  },
  termsOfDigitalServices: `${Environment.API.Webshop.url}${LOMA_REFERENCE_QUERY}/fi/footermenu/verkkopalvelustamme/digitaalisten-palveluiden-kayttoehdot/`,
  termsOfOwnership: `${Environment.API.Webshop.url}${LOMA_REFERENCE_QUERY}/fi/omistaminen/omistajien-digipalvelut/`,
  termsOfRental: `${Environment.API.Webshop.url}${LOMA_REFERENCE_QUERY}/fi/omistaminen/viikko-osake/vuokravalitys/`,
  webshop: `${Environment.API.Webshop.url}${LOMA_REFERENCE_QUERY}`,
  webshopSignUpComplete: `${Environment.API.Webshop.url}${LOMA_REFERENCE_QUERY}/fi/sign-up-complete/`,
  welcomePresentation: `${Environment.API.Webshop.url}${LOMA_REFERENCE_QUERY}/fi/omistaminen/tervetuloa-esittelyyn/`,
}
